import { dataDataMarket } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDataMarket = /*#__PURE__*/createIcon(dataDataMarket)
export default IconDataMarket
